@if (show) {
  <rds-toaster class="toastr">
    <rds-toast [attr.type]="type">{{ message }}</rds-toast>
  </rds-toaster>
}
